import React from 'react';

import { useNotchSpacerBackground } from './useNotchSpacerBackground';

const NavNotchSpacer = () => {
  const notchSpacerRef = useNotchSpacerBackground();

  return <div className="nav-notch-spacer" ref={notchSpacerRef} />;
};

export default NavNotchSpacer;
